<a
    *ngIf="externLink; else internalLink"
    [href]="externLink"
    target="_blank" rel="noopener noreferrer"
    class="primary-btn text-decoration-none px-4 py-2 text-uppercase rounded-0 text-white text-center d-block"
    [attr.title]="ariaLabel || text"
    [attr.aria-label]="ariaLabel || text"
>
    {{text}}
</a>

<ng-template #internalLink>
    <a
        [routerLink]="routerLinkValue"
        class="primary-btn text-decoration-none px-4 py-2 text-uppercase rounded-0 text-white text-center d-block"
        [attr.title]="ariaLabel || text"
        [attr.aria-label]="ariaLabel || text"
    >
        {{text}}
    </a>
</ng-template>

